<div class="fixed bottom-6 md:bottom-12 z-[1000]" [ngStyle]="{'right': buttonPosition()}">
    <button class="w-[72px] h-[72px] bg-primary rounded-full flex items-center justify-center relative border border-white">
        <svg-icon src="assets/svgs/ellipsis-message.svg"/>
        @if (unreadCount() > 0) {
            <div class="unread-count">
                <span class="w-6 text-center text-white text-base font-normal">{{unreadCount()}}</span>
            </div>   
        }
    </button>
</div>